import { FREE_PLAN, PLAN_MARKETING, formatCheckIntervalLabel } from '../planMarketing'

export const SSL_DOMAIN_MONITORING_SECTIONS = [
  {
    heading: 'Why monitor SSL and domain expiry?',
    paragraphs: [
      'An expired SSL certificate breaks HTTPS for every visitor. An expired domain registration can take your entire site offline—or worse, let someone else register it.',
      'Certificate and domain renewals are easy to forget until something fails. Automated expiry monitoring gives you weeks or months of warning.',
    ],
  },
  {
    heading: 'What Pingscalate checks',
    paragraphs: [
      'SSL monitors connect to your hostname on the configured port (default 443) and read the certificate expiry date. Domain monitors use RDAP lookups to find when a domain registration expires.',
      'Checks run on a daily schedule (or less often if you choose a longer interval). Results appear in your dashboard alongside HTTP uptime monitors.',
    ],
  },
  {
    heading: 'Alert thresholds you control',
    paragraphs: [
      'Set an alert threshold in days—for example, alert when a certificate expires within 14 days. Pingscalate marks the monitor as down when expiry falls within your threshold and sends Slack or email alerts through your escalation policy.',
      'Escalation policies support recheck intervals and high-priority escalation, the same as HTTP monitors.',
    ],
  },
  {
    heading: 'SSL/domain limits by plan',
    paragraphs: [
      `Every plan includes SSL and domain expiry monitoring. The free plan includes ${PLAN_MARKETING.free.sslDomainMonitors} SSL/domain monitor; Pro includes ${PLAN_MARKETING.pro.sslDomainMonitors}; Max includes ${PLAN_MARKETING.max.sslDomainMonitors}.`,
      `HTTP monitors and SSL/domain monitors have separate limits—your ${FREE_PLAN.monitors} free HTTP monitors do not count against your SSL/domain allowance.`,
    ],
  },
  {
    heading: 'Getting started',
    paragraphs: [
      `Add an SSL or domain monitor from the Monitors page, set your alert threshold, and link an escalation policy. The free plan includes ${FREE_PLAN.monitors} HTTP monitors, ${formatCheckIntervalLabel(FREE_PLAN.intervalMinutes)}, and one SSL/domain monitor—no credit card required.`,
    ],
  },
] as const
